const capitalize = require('./capitalize');

module.exports = name => capitalize(name.split('-').join(' '));
